module.exports = __webpack_public_path__ + "img/stop.52fdd21c.svg";